export const Globalimages = {
  image1: "/images/globalimages/Group 44827.svg",
  image2: "/images/globalimages/Group 44828.svg",
  image3: "/images/globalimages/Group 44829.svg",
  image4: "/images/globalimages/Group 44830.svg",
  image5: "/images/globalimages/Group 44831.svg",
  image6: "/images/globalimages/Group 44832.svg",
  image7: "/images/globalimages/Group 44833.svg",
  image8: "/images/globalimages/Group 44834.svg",
  image9: "/images/globalimages/Group 44835.svg",
  image10: "/images/globalimages/Group 44836.svg",
  image11: "/images/globalimages/Group 44837.svg",
  image12: "/images/globalimages/Group 44838.svg",
  image13: "/images/globalimages/Group.svg",
  logo: "/images/globalimages/Group 44839.svg",
};